import { render, staticRenderFns } from "./TourGroup.vue?vue&type=template&id=50f07bbc&scoped=true&"
import script from "./TourGroup.vue?vue&type=script&lang=js&"
export * from "./TourGroup.vue?vue&type=script&lang=js&"
import style0 from "./TourGroup.vue?vue&type=style&index=0&id=50f07bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f07bbc",
  null
  
)

export default component.exports